module.exports = __webpack_public_path__ + "img/DFW_DarkSword.b6cfa42b.png";